import style from "./ExpertGroupsContent.module.scss";
import ExpertGroupsForAppMode from "../../../components/ExpertGroups/appmode/ExpertGroupsForAppMode";
import classNames from "classnames";
import flags from "../../featureFlags/flags";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { useDispatch, useSelector } from "react-redux";
import { selectDitaContent } from "../../../components/Content/ContentSlice";
import { getExpertGroupFromUrl } from "../../../components/ExpertGroups/ExpertGroupUtils";

const ExpertGroupContent = ({ onClickCollapseButton, link, isOpen, showCollapseButton }) => {
  const userUpdatedExpertGroups = useBooleanFlagValue(flags.UPDATED_EXPERT_GROUPS, false);
  const dispatch = useDispatch();
  let expertGroup;
  const content = useSelector(selectDitaContent);
  if (userUpdatedExpertGroups) {
    if (link) {
      expertGroup = getExpertGroupFromUrl(link, content, dispatch);
      console.log(expertGroup);
    }
  }
  return isOpen ? (
    <div className={style.expertGroupWrapper}>
      <div className={style.expertGroupContent}>
        <span className="size-18 semibold">Expert groups</span>
        {showCollapseButton && (
          <button
            className={style.toggleButton}
            onClick={() => onClickCollapseButton()}
            data-testid="show-all"
          >
            <span className={classNames("size-14", style.hideText)}>Hide</span>
            <i className="fa banner-head-topic fa-angle-up"></i>
          </button>
        )}
      </div>

      {userUpdatedExpertGroups && expertGroup ? (
        <div>{expertGroup}</div>
      ) : (
        <ExpertGroupsForAppMode link={link} />
      )}
    </div>
  ) : null;
};

export default ExpertGroupContent;
